import LsdApiModel from './global/LsdApiModel';

export default class AccountingDocumentIdModel extends LsdApiModel {
	static get path(): string {
		return '/accounting_documents/ids/{?id}';
	}
}
